import YFormEmailLabel from './EmailLabel';

export { YFormEmailLabel };
export default YFormEmailLabel;
